import { useState, useEffect } from "react";

interface Column {
  name: string;
}

export function useColumnVisibility(fields: Column[]) {
  const [visibleColumns, setVisibleColumns] = useState<Column[]>([]);
  const [columnWidths, setColumnWidths] = useState<Record<string, number>>({});

  useEffect(() => {
    if (fields && fields.length > 0) {
      setVisibleColumns(fields);

      const widths: Record<string, number> = {};
      fields.forEach(f => (widths[f.name] = 200));

      setColumnWidths(widths);
    }
  }, [fields]);

  const handleColumnResize = (name: string, newWidth: number) => {
    setColumnWidths(prev => ({
      ...prev,
      [name]: newWidth,
    }));
  };

  return {
    visibleColumns,
    setVisibleColumns,
    columnWidths,
    handleColumnResize,
  };
}
